import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import DatePickerInput from "../../../share/input/DatePicker";
import { ReactComponent as Cancel } from "../../../../Assets/Image/svg/cancel.svg";
import { BtnPrimary } from "../../../share/buttons/Btn";
import Inputs from "../../../share/input/Inputs";
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";
import IconButton from "../../../share/buttons/IconButton";
import useFetch from "../../../../Hooks/useFetch";
import { useCreate } from "../../../../Context/CreateContext";

const AccessibilityInfo = ({ close, getBootcampRoles }) => {
    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();

    const { phaseStatus, setPhaseStatus, bootCamp, edit, setEdit } =
        useCreate();
    const [call, setCall] = useState(null);

    const [role, setRole] = useState({
        bootcamp: null,
        first_name: "",
        username: null,
        roll_type: "",
    });

    const submitForm = () => {
        if (edit) {
            editRole.reFetch();
            //TODO : pak kardane modal bad az patch
            close();
        } else {
            const formData = new FormData();

            formData.append("bootcamp", bootCamp?.id);
            formData.append("first_name", role.first_name);
            formData.append("username", role.username);
            formData.append("roll_type", role.roll_type);

            setCall(formData);
            newRole.reFetch();

            setRole({
                bootcamp: null,
                first_name: "",
                username: null,
                roll_type: "",
            });

            setEdit("");

            close();
        }
    };

    useEffect(() => {
        if (edit) {
            getRoleId.reFetch();
        }
    }, [edit]);

    const newRole = useFetch({
        method: "POST",
        url: `UserBootcampRollService`,
        noHeader: false,
        caller: getBootcampRoles,
        trigger: false,
        data: call,
    });

    const getRoleId = useFetch({
        method: "GET",
        url: `UserBootcampRollService/${edit}`,
        noHeader: false,
        setter: setRole,
    });

    const editRole = useFetch({
        method: "PATCH",
        url: `UserBootcampRollService/${edit}`,
        noHeader: false,
        caller: getBootcampRoles,
        data: role,
    });

    return (
        <div className=" relative">
            <button
                onClick={() => close(false)}
                className="AddnewsupportTicket-cancel absolute  "
            >
                <div>
                    <Cancel />
                </div>
            </button>
            <h3 className=" text-center text-[#77498F] text-[20px] font-bold mb-20">
                افزودن دسترسی جدید
            </h3>
            <form
                onSubmit={handleSubmit(submitForm)}
                className="flex flex-col justify-center"
            >
                <input
                    register={{
                        required: {
                            value: true,
                            message: "Enter Name",
                        },
                    }}
                    onChange={(e) => {
                        setRole({ ...role, first_name: e.target.value });
                    }}
                    type="text"
                    name="name"
                    full={true}
                    control={control}
                    placeholder="نام*"
                    className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem] input"
                />
                <input
                    register={{
                        required: {
                            value: true,
                            message: "Enter Name",
                        },
                    }}
                    onChange={(e) => {
                        setRole({ ...role, username: e.target.value });
                    }}
                    type="number"
                    name="number"
                    full={true}
                    control={control}
                    placeholder="شماره تماس*"
                    className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem] input"
                />
                <div className="mb-6">
                    <p className="text-[1.8rem] mb-6">دسترسی مورد نظر:</p>
                    <div className="flex justify-around items-center gap-24">
                        <div className="flex items-center">
                            <input
                                register={{
                                    required: {
                                        value: true,
                                    },
                                }}
                                type="radio"
                                name="access"
                                id="access1"
                                value="Professor"
                                control={control}
                                className="PriceForm w-10 input"
                                onChange={(e) =>
                                    setRole({
                                        ...role,
                                        roll_type: e.target.value,
                                    })
                                }
                            />
                            <label
                                className="text-[1.4rem] mr-3"
                                htmlFor="cost1"
                            >
                                استاد
                            </label>
                        </div>
                        <div className="flex items-center">
                            <input
                                register={{
                                    required: {
                                        value: true,
                                    },
                                }}
                                type="radio"
                                name="access"
                                id="access1"
                                value="Mentor"
                                control={control}
                                className="PriceForm w-10 input"
                                onChange={(e) =>
                                    setRole({
                                        ...role,
                                        roll_type: e.target.value,
                                    })
                                }
                            />
                            <label
                                className="text-[1.4rem] mr-3"
                                htmlFor="cost1"
                            >
                                منتور
                            </label>
                        </div>
                        <div className="flex items-center">
                            <input
                                register={{
                                    required: {
                                        value: true,
                                    },
                                }}
                                type="radio"
                                name="access"
                                id="access1"
                                value="Coach"
                                control={control}
                                className="PriceForm w-10 input"
                                onChange={(e) =>
                                    setRole({
                                        ...role,
                                        roll_type: e.target.value,
                                    })
                                }
                            />
                            <label
                                className="text-[1.4rem] mr-3"
                                htmlFor="cost1"
                            >
                                مربی
                            </label>
                        </div>
                        <div className="flex items-center">
                            <input
                                register={{
                                    required: {
                                        value: true,
                                    },
                                }}
                                type="radio"
                                name="access"
                                id="access1"
                                value="Referee"
                                control={control}
                                className="PriceForm w-10 input"
                                onChange={(e) =>
                                    setRole({
                                        ...role,
                                        roll_type: e.target.value,
                                    })
                                }
                            />
                            <label
                                className="text-[1.4rem] mr-3"
                                htmlFor="cost1"
                            >
                                داور
                            </label>
                        </div>
                    </div>
                </div>
                <p className="text-[#77498F] cursor-pointer text-2xl color- mb-16">
                    مشاهده دسترسی‌های سمت انتخابی
                </p>
                <div className="flex gap-48 self-end">
                    <BtnPrimary
                        className="py-[20px] px-[81px] mr-auto"
                        text="ثبت"
                    />
                </div>
            </form>
        </div>
    );
};

export default AccessibilityInfo;
